import React, { useState } from 'react';
import { Search, Instagram, Facebook, Linkedin, Twitter, Youtube } from 'lucide-react';

function SearchForm({ onSubmit, loading, error }) {
  const [url, setUrl] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (url.trim()) {
      onSubmit(url.trim());
    }
  };

  return (
    <div className="search-section">
      <form className="search-form" onSubmit={handleSubmit}>
        <div className="search-input-wrapper">
          <input
            type="text"
            className="search-input"
            placeholder="Paste social media profile URL..."
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            disabled={loading}
          />
          <button 
            type="submit" 
            className="search-button"
            disabled={loading || !url.trim()}
          >
            <Search size={20} />
          </button>
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <div className="platform-icons">
          <div className="platform-icon" title="Instagram">
            <Instagram size={24} />
          </div>
          <div className="platform-icon" title="Facebook">
            <Facebook size={24} />
          </div>
          <div className="platform-icon" title="LinkedIn">
            <Linkedin size={24} />
          </div>
          <div className="platform-icon" title="Twitter">
            <Twitter size={24} />
          </div>
          <div className="platform-icon" title="YouTube">
            <Youtube size={24} />
          </div>
        </div>
      </form>
    </div>
  );
}

export default SearchForm;
